// @flow
// The backend server is in the same domain - this works in other environment that DEV - in your local dev env, set the environment variable below:
// export REACT_APP_NEVEPORTAL_SERVER_API_URL=https://test.neve.fi/api and run "yarn build"
export const apiUrl = process.env.REACT_APP_NEVEPORTAL_SERVER_API_URL || '/api'
export const instrumentationKey = process.env.REACT_APP_INSTRUMENTATION_KEY
export const timezone = process.env.TZ || 'Europe/Helsinki'

export const PASSWORD_MAX_LENGTH = 100
export const EMAIL_MAX_LENGTH = 100
